function BoxAbout(container){
	var _this = this,
		contentItems = '';

	this.container = $(container);
	this.index = this.container.index();
	this.control = this.container.find('a');
	this.control.bind('active', function(e){
		if (!$(this).is('.dotted-active')) {
			if ($(this).data('active')) {
				// кликнули по активному элементу, его и скрываем
				$(this).removeClass('dotted-active').data('active',!$(this).data('active'));
				$($(this).attr('href')).hide();
				_this.active = jQuery();
			} else {
				// кликнули по неактивному, показываем его, а предыдущий активный скрываем
				if (typeof _this.active != 'undefined' && _this.active.length) {
					_this.active.removeClass('dotted-active').data('active',!_this.active.data('active'));
					$(_this.active.attr('href')).hide();

					rHelperData(_this.active);
				}

				_this.active = $(this);
				$(this).addClass('dotted-active').data('active',!$(this).data('active'));
				$($(this).attr('href')).show();
			}
		} else {
			_this.control.eq(0).trigger('active');
		}
	});
	this.control.click(function(){
		if (!$(this).is('.dotted-active')) {
			$(this).trigger('active');
			rHelperClick($(this));
		}
		return false;
	});

	this.active = jQuery();
	var active = _this.control.filter('.dotted-active').eq(0);
	this.control.each(function(i){
		var control = $(this);
		var id = control.attr('href');
		if(typeof id != "string" || id[0] != '#') {
			return;
		}
		var close = $(id).find('.j-switch-text-close');

		close.click(function(){
			control.click();
			var controlScrollTop = control.offset().top,
				pageScrollTop = $('html').scrollTop() + $('body').scrollTop();
			if (pageScrollTop > controlScrollTop) {
				$('html,body').scrollTop(controlScrollTop);
			}
		});

		if (i != 0) contentItems += ',';
		contentItems += id;

		if (control.data('active')) {
			active = control;
		}
		control.data({'active': false}).removeClass('dotted-active');
	});
	$(contentItems).hide();
	_this.contentItems = $(contentItems);
	if (!active.length) {
		active = _this.control.eq(0);
	}
	active.trigger('active');
}

if (typeof define === "function" && define.amd) {
	define('Controls/BoxAbout',['router','scrollTo'], function() {
		return BoxAbout;
	});
};
